const subscriptionSuccessPage = {
  en: {
    subscriptionSuccessPage: {
      noSession: "No payment session found",
      timeout: "Payment status check timed out. Please check your email for confirmation.",
      expired: "Payment session expired. Please try again.",
      checkError: "Error checking payment status",
      processing: "Processing Payment...",
      pleaseWait: "Please wait while we confirm your payment",
      success: "Payment Successful!",
      activated: "Your subscription has been activated",
      failed: "Payment Failed",
      somethingWrong: "Something went wrong with your payment",
      plan: "Plan:",
      amount: "Amount:",
      transactionId: "Transaction ID:",
      backToPlans: "Back to Plans",
      goToDashboard: "Go to Dashboard",
      timeoutNote: "If you have been charged, your subscription will be activated shortly. Check your email for confirmation."
    }
  },
  fr: {
    subscriptionSuccessPage: {
      noSession: "Aucune session de paiement trouvée",
      timeout: "La vérification du statut du paiement a expiré. Veuillez consulter votre e-mail pour la confirmation.",
      expired: "La session de paiement a expiré. Veuillez réessayer.",
      checkError: "Erreur lors de la vérification du statut du paiement",
      processing: "Traitement du paiement...",
      pleaseWait: "Veuillez patienter pendant que nous confirmons votre paiement",
      success: "Paiement réussi !",
      activated: "Votre abonnement a été activé",
      failed: "Échec du paiement",
      somethingWrong: "Un problème est survenu avec votre paiement",
      plan: "Plan :",
      amount: "Montant :",
      transactionId: "ID de transaction :",
      backToPlans: "Retour aux plans",
      goToDashboard: "Aller au tableau de bord",
      timeoutNote: "Si vous avez été débité, votre abonnement sera activé sous peu. Consultez votre e-mail pour la confirmation."
    }
  }
};

export default subscriptionSuccessPage;
